<template>
  <BaseElButton
    type="primary"
    size="small"
    class="ai-gen-button"
    @click="$emit('click')"
  >
    <FlexLayout class="text-normal leading-[16px]" align="center" :gap="8" inline>
      <slot />
      <MaterialIcon>
        auto_awesome
      </MaterialIcon>
    </FlexLayout>
  </BaseElButton>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AIGenButton',
})
</script>

<style scoped lang="postcss">
.ai-gen-button {
  @apply w-[fit-content] h-[fit-content];
}
</style>
